module.exports = {
      id: "device-usage",
      viewBox: "0 0 11 20",
      url: __webpack_public_path__ + "assets/img/sprite-8cafc1.svg#device-usage",
      toString: function () {
        return this.url;
      }
    }